import { ReactNode, MouseEvent } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Box, Link, Typography } from '@sso/components';
import { useTrafficPrefix } from '@sso/context-providers';

type Props = {
  href: string;
  onClick: (e: MouseEvent<HTMLAnchorElement>) => void;
  isSuperBowlSSODeckExperienceForCart?: boolean;
  legalDisclaimer: ReactNode;
  className?: string;
};

export const SignInLink = ({
  className,
  href,
  onClick,
  isSuperBowlSSODeckExperienceForCart = false,
  legalDisclaimer,
}: Props) => {
  const intl = useIntl();
  const trafficPrefix = useTrafficPrefix();
  return (
    <div id='sign-in-link' data-testid='sign-in-link' className={className}>
      {isSuperBowlSSODeckExperienceForCart && (
        <FormattedMessage
          id='CREATE_AN_ACCOUNT_OR_SIGN_IN'
          values={{
            a: chunk => (
              <Link
                id='login-link'
                href={href}
                target='_self'
                onClick={onClick}
                dataEid={`${trafficPrefix}.sign_in.link'`}
                text={chunk}
              />
            ),
          }}
        >
          {chunks => <p>{chunks}</p>}
        </FormattedMessage>
      )}
      {/* TOS and Privacy Policy */}
      {legalDisclaimer}
      {!isSuperBowlSSODeckExperienceForCart && (
        <Box display='flex' gap='xs'>
          <Typography component='p' text={intl.formatMessage({ id: 'ALREADY_HAVE_ACCOUNT' })} />
          <Link
            id='login-link'
            href={href}
            target='_self'
            onClick={onClick}
            dataEid={`${trafficPrefix}.sign_in.link'`}
            text={intl.formatMessage({ id: 'SIGN_IN_BUTTON' })}
          />
        </Box>
      )}
    </div>
  );
};
